module.exports = __webpack_public_path__ + "img/dashboard_2.07e29dcf.svg";